import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {MenuItems} from '../../shared/menu-items/menu-items';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ExactLogService {
  constructor(private helper: Helper, private http: HttpClient, private menuItems: MenuItems) {
  }


  public getLogs(gridData = new HttpParams()) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/exact/logs/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getCrmUpdates(gridData = new HttpParams()) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/exact/exact-crm-updates/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getRetries(gridData = new HttpParams()) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/exact/exact-retries/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getCrmUpdateNotificationsCount() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/exact/notifications-count')
      .pipe(catchError(res => this.helper.catchError(res))).subscribe(data => {
        this.menuItems.setBadge(data['crmUpdate'], 'menu.exact_crm_updates');
        this.menuItems.setBadge(data['retries'], 'menu.exact_retries');
      });
  }

  public acceptExactCrmUpdate(id) {
    return this.http.post(environment.apiUrl + '/backoffice/exact/exact-crm-updates/accept', {id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public rejectExactCrmUpdate(id) {
    return this.http.post(environment.apiUrl + '/backoffice/exact/exact-crm-updates/reject', {id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public acceptExactRetries(id) {
    return this.http.post(environment.apiUrl + '/backoffice/exact/exact-retries/accept', {id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public rejectExactRetries(id) {
    return this.http.post(environment.apiUrl + '/backoffice/exact/exact-retries/reject', {id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public exactCrmCompare(id) {
    return this.http.post(environment.apiUrl + '/backoffice/exact/exact-crm-compare', {id})
  }
}
